import { Card, CardBody, Col, InputGroup, InputGroupText } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CustomForm, CustomFormSubmit, FavoriteChocolatesTitle, FavoriteColorsTitle, FavoriteThemeTitle, OptionsFormGroup, PixelstrapThemeTitle } from "../../../../Constant";
import { CHOCOLATE_DATA, COLOR_DATA, CUSTOM_FORMS, FAVORATE_THEME_DATA, PIXEL_DATA } from "../../../../Data/FormControl/InputGroups";
import CustomFormSelect from "./Common/CustomFormSelect";

const CustomForms = () => {
  return (
    <Col md="6">
    <Card>
        <CommonCardHeader title={CustomForm} span={CUSTOM_FORMS} />
      <CardBody className="common-flex main-custom-form">
        <InputGroup>
          <InputGroupText htmlFor="inputGroupSelect01">{OptionsFormGroup}</InputGroupText>
          <CustomFormSelect inputId='inputGroupSelect01' title={PixelstrapThemeTitle} options={PIXEL_DATA}/>
        </InputGroup>
        <InputGroup>
          <CustomFormSelect inputId='inputGroupSelect02' title={FavoriteColorsTitle} options={COLOR_DATA}/>
          <InputGroupText htmlFor="inputGroupSelect02">{OptionsFormGroup}</InputGroupText>
        </InputGroup>
        <InputGroup>
          <Btn color='secondary' outline><i className="icofont icofont-credit-card"></i></Btn>
          <CustomFormSelect inputId='inputGroupSelect03' title={FavoriteChocolatesTitle} options={CHOCOLATE_DATA}/>
        </InputGroup>
        <InputGroup>
          <CustomFormSelect inputId='inputGroupSelect04' title={FavoriteThemeTitle} options={FAVORATE_THEME_DATA}/>
          <Btn color='secondary' outline>{CustomFormSubmit}</Btn>
        </InputGroup>
      </CardBody>
    </Card>
  </Col>
  )
};

export default CustomForms;
